exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__PageNavigator__root {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 72px;\n  padding: 0 16px;\n}\n\n.DS__PageNavigator__button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 36px;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.DS__PageNavigator__button:hover,\n  .DS__PageNavigator__button:focus {\n    background-color: #f6f8fc;\n  }\n\n.DS__PageNavigator__button.DS__PageNavigator__active {\n    background-color: #f4f9e6;\n  }\n\n.DS__PageNavigator__button.DS__PageNavigator__disabled {\n    color: #7a869a;\n    pointer-events: none;\n    cursor: default;\n  }\n\n.DS__PageNavigator__pages {\n  display: flex;\n  align-items: center;\n}\n\n.DS__PageNavigator__ellipsis {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 38px;\n}\n\n.DS__PageNavigator__fieldRoot {\n  width: 64px !important;\n  padding: 0 5px;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__PageNavigator__root",
	"button": "DS__PageNavigator__button",
	"active": "DS__PageNavigator__active",
	"disabled": "DS__PageNavigator__disabled",
	"pages": "DS__PageNavigator__pages",
	"ellipsis": "DS__PageNavigator__ellipsis",
	"fieldRoot": "DS__PageNavigator__fieldRoot"
};